import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import MainMeta from '../../metaTags/MainMeta.jsx';
import ButtonLink from "../../components/Button/index.js";
import PDFRenderer from "../../helpers/PDFRenderer.js";

import PDFfile1 from "../../assets/pdf/01_compressed.pdf"
// import PDFfile2 from "../../assets/pdf/02_compressed.pdf"
import PDFfile2 from "../../assets/pdf/08_compressed.pdf"
import PDFfile3 from "../../assets/pdf/03_compressed.pdf"
import PDFfile4 from "../../assets/pdf/04_compressed.pdf"
import PDFfile5 from "../../assets/pdf/05_compressed.pdf"
import PDFfile6 from "../../assets/pdf/06_compressed.pdf"
import PDFfile7 from "../../assets/pdf/07_compressed.pdf"
import Menu1 from "../../assets/images/menu1.webp"
import Menu2 from "../../assets/images/menu2.webp"
import Menu3 from "../../assets/images/menu3.webp"
import Menu5 from "../../assets/images/menu5.webp"
import Menu6 from "../../assets/images/menu6.webp"
import Menu8 from "../../assets/images/menu8.webp"
import Menu9 from "../../assets/images/menu9.webp"
import Menu10 from "../../assets/images/menu10.webp"
import Menu11 from "../../assets/images/menu11.webp"
import Menu12 from "../../assets/images/menu12.webp"

import "../../style/title.scss";
import "./index.scss";

function Menu(){
  const { t } = useTranslation();
  const { lang } = useParams(); // Получаем текущий язык из URL
  
  const images = [Menu1, Menu2, Menu3, Menu5, Menu6, Menu8, Menu9, Menu10, Menu11, Menu12];
  const [loadedImages, setLoadedImages] = useState({}); // Отслеживаем состояние загрузки каждого изображения

  const handleImageLoad = (src) => {
    setLoadedImages((prev) => ({ ...prev, [src]: true })); // Помечаем изображение как загруженное
  };

  return(
        <div className="menu-wrapper">
          <MainMeta />
          <div className='title'>
              <div className='text big'>{t('menu')}</div>
              <div className='text desktop'>{t('title')}</div>
              <div className='text mobile'><span>{t('title-part1')}</span><span>{t('title-part2')}</span></div>
          </div>

          <ButtonLink to={`/${lang}/reservation`} className="btn-menu btn-with-borders">
            <span>{t('reservation')}</span>
          </ButtonLink>

          <div className="part-pdf">
            <PDFRenderer pdfUrl={PDFfile1}/>
          </div>

          <div className="part-pdf">
            <PDFRenderer pdfUrl={PDFfile2}/>
          </div>

          <div className="part part-3img">
            <div className="menu-img">
            {!loadedImages[Menu6] && <div className="spinner"></div>}
                <img
                  src={Menu6}
                  alt=""
                  onLoad={() => handleImageLoad(Menu6)}
                  style={loadedImages[Menu6] ? {} : { visibility: 'hidden' }}
                />
            </div>
            <div className="menu-img">
            {!loadedImages[Menu2] && <div className="spinner"></div>}
                <img
                  src={Menu2}
                  alt=""
                  onLoad={() => handleImageLoad(Menu2)}
                  style={loadedImages[Menu2] ? {} : { visibility: 'hidden' }}
                />
            </div>
            <div className="menu-img">
            {!loadedImages[Menu8] && <div className="spinner"></div>}
                <img
                  src={Menu8}
                  alt=""
                  onLoad={() => handleImageLoad(Menu8)}
                  style={loadedImages[Menu8] ? {} : { visibility: 'hidden' }}
                />
            </div>
          </div>

          <div className="part-pdf">
            <PDFRenderer pdfUrl={PDFfile3}/>
          </div>
          
          <div className="part part-2img">
            <div className="menu-img">
              {!loadedImages[Menu9] && <div className="spinner"></div>}
                  <img
                    src={Menu9}
                    alt=""
                    onLoad={() => handleImageLoad(Menu9)}
                    style={loadedImages[Menu9] ? {} : { visibility: 'hidden' }}
                  />
              </div>
              <div className="menu-img">
              {!loadedImages[Menu10] && <div className="spinner"></div>}
                  <img
                    src={Menu10}
                    alt=""
                    onLoad={() => handleImageLoad(Menu10)}
                    style={loadedImages[Menu10] ? {} : { visibility: 'hidden' }}
                  />
              </div>
          </div>

          <div className="part-pdf">
            <PDFRenderer pdfUrl={PDFfile4}/>
          </div>
          <div className="part part-3img">
            <div className="menu-img">
            {!loadedImages[Menu12] && <div className="spinner"></div>}
                <img
                  src={Menu12}
                  alt=""
                  onLoad={() => handleImageLoad(Menu12)}
                  style={loadedImages[Menu12] ? {} : { visibility: 'hidden' }}
                />
            </div>
            <div className="menu-img">
            {!loadedImages[Menu11] && <div className="spinner"></div>}
                <img
                  src={Menu11}
                  alt=""
                  onLoad={() => handleImageLoad(Menu11)}
                  style={loadedImages[Menu11] ? {} : { visibility: 'hidden' }}
                />
            </div>
            <div className="menu-img">
            {!loadedImages[Menu3] && <div className="spinner"></div>}
                <img
                  src={Menu3}
                  alt=""
                  onLoad={() => handleImageLoad(Menu3)}
                  style={loadedImages[Menu3] ? {} : { visibility: 'hidden' }}
                />
            </div>
          </div>

          <div className="part-pdf">
            <PDFRenderer pdfUrl={PDFfile5}/>
          </div>
          <div className="part-pdf">
            <PDFRenderer pdfUrl={PDFfile6}/>
          </div>
          
          <div className="part part-2img crop">
            <div className="menu-img ">
              {!loadedImages[Menu1] && <div className="spinner"></div>}
                  <img
                    src={Menu1}
                    alt=""
                    onLoad={() => handleImageLoad(Menu1)}
                    style={loadedImages[Menu1] ? {} : { visibility: 'hidden' }}
                  />
              </div>
              <div className="menu-img">
              {!loadedImages[Menu5] && <div className="spinner"></div>}
                  <img
                    src={Menu5}
                    alt=""
                    onLoad={() => handleImageLoad(Menu5)}
                    style={loadedImages[Menu5] ? {} : { visibility: 'hidden' }}
                  />
              </div>
          </div>

          <div className="part-pdf">
            <PDFRenderer pdfUrl={PDFfile7}/>
          </div>
          
          <ButtonLink to={`/${lang}/reservation`} className="btn-menu btn-with-borders btn-add-menu">
            <span>{t('reservation')}</span>
          </ButtonLink>
        </div>
    )
}

export default Menu;